module.exports = __webpack_public_path__ + "assets/img/favicon/favicon-16x16.6ec028b2512929c9180e5940a5db82ce.png";